import React, { useEffect } from "react";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import Box from "components/common/Box";
import { config } from "config";
import { intercom } from "library/tracker/intercom";
import { BOTTOM_NAV_HEIGHT } from "components/allInOneDashboard/constants/bottomNavConfig";
import {
  BRAND_BLUE,
  BRAND_BLUE_DARK,
} from "components/allInOneDashboard/constants/mobileTheme";

const LAUNCHER_SELECTORS = [
  ".intercom-launcher",
  ".intercom-launcher-frame",
  ".intercom-lightweight-app-launcher",
];

const hideIntercomLauncher = () => {
  LAUNCHER_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.style.setProperty("display", "none", "important");
    });
  });
};

const SupportFab = () => {
  const isNativeApp = config.isMobileApp;
  const bottom = isNativeApp
    ? `calc(${BOTTOM_NAV_HEIGHT}px + 12px + env(safe-area-inset-bottom, 0px))`
    : "calc(16px + env(safe-area-inset-bottom, 0px))";

  useEffect(() => {
    hideIntercomLauncher();
    const timer = window.setInterval(hideIntercomLauncher, 1500);
    return () => {
      window.clearInterval(timer);
      LAUNCHER_SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          el.style.removeProperty("display");
        });
      });
    };
  }, []);

  return (
    <Box
      component="button"
      type="button"
      aria-label="Support chat"
      onClick={() => intercom.show()}
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        right: 16,
        bottom,
        zIndex: 1190,
        width: 56,
        height: 56,
        borderRadius: "50%",
        border: 0,
        p: 0,
        m: 0,
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: BRAND_BLUE,
        color: "#fff",
        boxShadow: "0 8px 24px rgba(56, 126, 209, 0.35)",
        "&:hover": { bgcolor: BRAND_BLUE_DARK },
      }}
    >
      <HeadsetMicOutlinedIcon sx={{ fontSize: 28 }} />
    </Box>
  );
};

export default SupportFab;
